import NewPickOrder from "../../../../components/@documents/pick_orders/NewPickOrder";
import {routeTypes} from "../../../../hooks/useSystemRoutes";

export default function PickOrderNewPage() {

    return (
        <NewPickOrder
            routeType={routeTypes.admin}
        />
    )
}